/**
 * Font Awesome utility tokens: family (`fa-solid`), name (`fa-house`) and
 * modifiers (`fa-spin`, `fa-fw`, `fa-2x`). They all start with `fa-`.
 */
export const FA_TOKEN = /^fa-[a-z0-9-]+$/;

/** ARIA and data attributes: inert metadata, safe to forward to the glyph. */
/**
 * Style families Atlas does not draw. Atlas icons are Font Awesome Light only,
 * so any other family in a name is dropped and `fa-light` is applied instead.
 * `fa-brands` is kept: brand marks exist in no other family.
 */
export const FA_STYLE_TOKEN =
  /^fa-(solid|regular|light|thin|duotone|sharp|sharp-duotone|classic)$/;

export const FA_LIGHT = 'fa-light';

export const FA_BRANDS = 'fa-brands';

export const ALLOWED_PROP_PREFIX = /^(aria-|data-)/;

/** The rest of the forwardable surface — identity and presentation, no behaviour. */
export const ALLOWED_PROPS = new Set(['id', 'role', 'style', 'title']);
